import React, { useEffect, useState } from 'react';
import { Body, ContAppCont, Footer, Header, Note, GoToProjectButton } from './ContinueApplication.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Button, CircularProgress, IconButton } from '@material-ui/core';
import { CheckMarkIcon } from '@room-match/shared-ui-components';
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent level folder close icon
import { COLORS } from 'shared/constants/COLORS';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from '../../OpportunitiesContext';
import { ls } from 'shared/utils/ls';
import { useQueryClient } from 'react-query';
import { OPPORTUNITIES_QUERY_STRING } from 'shared/constants/QUERY_STRING';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
const { PRIMARY_TEXT, PASS_BUTTON_BORDER, ERROR_TEXT, DARK_GREEN_ICON } = COLORS;

interface Props {
  close: VoidFunction;
}

const ContinueApplicaiton: React.FC<Props> = ({ close }) => {
  const { getLS, removeLS } = ls();
  const [isLoading, setIsLoading] = useState(false);
  const { role_id, project_id, company_name, role_name } = JSON.parse(getLS('pending_job_application') || '{}');
  const applyToRole = useContextSelector(OpportunitiesContext, (state) => state.applyToRole);
  const setFilters = useContextSelector(OpportunitiesContext, (state) => state.setFilters);
  const [submitted, setSubmitted] = useState(false);
  const queryClient = useQueryClient();
  const history = useHistory();
  const handleApply = async () => {
    setIsLoading(true);
    await applyToRole(role_id, project_id, company_name, role_name).then(async (res) => {
      setIsLoading(false);

      if (res) {
        removeLS('pending_job_application');
        // setFilters({
        //   role_ids: [],
        //   project_ids: [],
        // });
        // await queryClient.invalidateQueries([OPPORTUNITIES_QUERY_STRING.OPPORTUNITY_LIST], {
        //   refetchInactive: true,
        // });
        setSubmitted(true);
        // setTimeout(() => {
        //   history.push(`${ROUTES.TALENT.OPPORTUNITIES}`);
        // }, 500);
        // close();
      }
    });
  };

  const handleClose = () => {
    removeLS('pending_job_application');
    history.push(`${ROUTES.TALENT.OPPORTUNITIES}`);
  };

  const goToProject = () => {
    removeLS('pending_job_application');
    close();
  };

  // useEffect to detect ESC key press
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      console.log(event.key);

      if (event.key === 'Escape') {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <ContAppCont>
      <Header>
        <CustomTypography fontSize={18}>Finish Submission</CustomTypography>
        <IconButton>
          <CloseIcon fontSize="small" onClick={handleClose} />
        </IconButton>
      </Header>
      <Body>
        <CustomTypography style={{ textAlign: 'center', marginBottom: 20 }}>
          You have started an application for this project. Would you like to continue?
        </CustomTypography>
        <CustomTypography fontWeight={600}>
          Company: <span style={{ color: PRIMARY_TEXT }}>{company_name}</span>
        </CustomTypography>
        <CustomTypography fontWeight={600}>
          Role: <span style={{ color: PRIMARY_TEXT }}>{role_name}</span>
        </CustomTypography>
      </Body>
      <Note>
        <CustomTypography fontSize={14} style={{ padding: 20, color: ERROR_TEXT }}>
          <span style={{ fontWeight: 700 }}>IMPORTANT:</span> The selected project might be outside of your normal
          project filters. Please be sure to check the project closely. You can view and submit yourself for this
          project below.
        </CustomTypography>
      </Note>
      <Footer>
        {/* <Button
          variant="outlined"
          color="primary"
          style={{ color: 'white', marginRight: 'auto' }}
          onClick={goToProject}
        >
          Go to project
        </Button> */}
        <GoToProjectButton variant="contained" onClick={goToProject}>
          Go to project
        </GoToProjectButton>
        {/* <Button variant="outlined" color="primary" style={{ marginLeft: 'auto', color: 'white' }}>
          Edit Profiles
        </Button> */}
        {submitted ? (
          <Button variant="outlined" style={{ width: 145, border: `1px solid ${PASS_BUTTON_BORDER}` }}>
            <CheckMarkIcon htmlColor={DARK_GREEN_ICON} />
            <CustomTypography fontSize={14} fontWeight={600} style={{ marginLeft: 5 }}>
              Submitted
            </CustomTypography>
          </Button>
        ) : (
          <Button variant="contained" color="primary" onClick={handleApply} style={{ width: 145 }}>
            {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Yes, Submit Now'}
          </Button>
        )}
      </Footer>
    </ContAppCont>
  );
};

export default ContinueApplicaiton;
